import {memo, useRef} from 'react'
import {css} from '@emotion/react'
import useOnResize from '@/hooks/useOnResize.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import NodeDesc from './NodeDesc.jsx'
import NodeIcons from './NodeIcons.jsx'
import NodeLower from './NodeLower.jsx'
import NodeProject from './NodeProject.jsx'
import NodeText from './NodeText.jsx'
import NodeUpper from './NodeUpper.jsx'
import NodeVersion from './NodeVersion.jsx'

const cssNodeInnerBox = css({
    display: 'grid',

    gridTemplate: `
        "icons desc  ver"
        "icons upper ver"
        "icons text  ver"
        "icons lower ver"
        "icons prj   prj" / auto auto 1fr auto auto
    `,

    placeItems: 'center start',
    position: 'relative',
    padding: '.4em .5em',
})

const cssNodeIcons = css({
    gridArea: 'icons',
})

const cssNodeDesc = css({
    gridArea: 'desc',
})

const cssNodeLower = css({
    gridArea: 'lower',
})

const cssNodeUpper = css({
    gridArea: 'upper',
})

const cssNodeText = css({
    gridArea: 'text',
})

const cssNodeVersion = css({
    gridArea: 'ver',
    alignSelf: 'end',
    marginLeft: 4,
})

const cssNodeProject = css({
    gridArea: 'prj',
    alignSelf: 'end',
})

const NodeInnerBox = ({node, onResize, ...props}) => {
    const map = useMapContext()
    map.useNodeChange(node, ['data'])
    const refEl = useRef()
    useOnResize(refEl, onResize)

    return (
        <div
            ref={refEl}
            css={cssNodeInnerBox}
            {...props}
        >
            <NodeIcons
                css={cssNodeIcons}
                node={node}
            />

            <NodeDesc
                css={cssNodeDesc}
                node={node}
            />

            <NodeLower
                css={cssNodeLower}
                node={node}
            />

            <NodeUpper
                css={cssNodeUpper}
                node={node}
            />

            <NodeText
                css={cssNodeText}
                node={node}
            />

            <NodeVersion
                css={cssNodeVersion}
                node={node}
            />

            <NodeProject
                css={cssNodeProject}
                node={node}
            />
        </div>
    )
}

const MemorizedNodeInnerBox = memo(NodeInnerBox, () => true)
MemorizedNodeInnerBox.displayName = 'NodeInnerBox'

export default MemorizedNodeInnerBox
